"use client";

import React, { useMemo, useState } from "react";
import { ImageProps } from "next/image";
import Image from "../imageV2/ImageV2";
import sanityLoader from "@/utils/sanity.utils";

interface NextImageProps extends ImageProps {
  fallbackSrc?: string;
}

export const SanityImg = ({ src, width, sizes, fallbackSrc, loading, ...rest }: NextImageProps) => {
  const fallbackImage = useMemo(() => {
    const envVariable = process.env.ENV ?? process.env.NEXT_PUBLIC_ENV;
    return envVariable === "SIT"
      ? "global-m-no-image-portrait_sp8io0.svg"
      : "no-image-square_xpvtmf.svg";
  }, []);

  const [useFallback, setUseFallback] = useState(false);

  const handleError = () => {
    if (!useFallback) {
      setUseFallback(true);
    }
  };

  let finalSrc: string | null = null;
  const imgSize = width ? +width : 300;

  if (typeof src === "string") {
    try {
      const url = new URL(src);

      if (url.search && width) {
        url.searchParams.set("w", (imgSize * 2).toString());
        url.searchParams.set("q", "95");
        finalSrc = url.toString();
      } else {
        finalSrc = `${src}?w=${imgSize * 2}&q=${95}`;
      }
    } catch {
      // Invalid or missing URL
      finalSrc = null;
    }
  }

  return useFallback ? (
    <Image
      src={fallbackImage}
      fallbackSrc={fallbackSrc}
      {...rest}
      quality={95}
      loading={loading ?? "lazy"}
      width={width}
    />
  ) : (
    <Image
      {...rest}
      src={finalSrc ?? src}
      width={width}
      sizes="(max-width: 768px) 100vw, 800px"
      onError={handleError}
      loading={loading ?? "lazy"}
      loader={sanityLoader}
    />
  );
};
